var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6153 6.6571C19.9803 6.9385 19.2997 7.1285 18.5854 7.21268C19.3141 6.77495 19.8745 6.08229 20.1391 5.25734C19.456 5.6614 18.6984 5.95722 17.8951 6.11596C17.2506 5.42811 16.3318 5 15.3145 5C13.3615 5 11.779 6.58255 11.779 8.53548C11.779 8.81206 11.8103 9.08143 11.8704 9.34118C8.93379 9.19447 6.32908 7.78749 4.58539 5.64697C4.27995 6.16887 4.10678 6.77736 4.10678 7.42433C4.10678 8.65092 4.7297 9.73321 5.67971 10.3657C5.10008 10.3465 4.55413 10.1878 4.07792 9.92321C4.07792 9.93764 4.07792 9.95207 4.07792 9.9665C4.07792 11.6789 5.2973 13.1075 6.91351 13.4322C6.61769 13.514 6.30503 13.5573 5.98275 13.5573C5.75426 13.5573 5.533 13.5356 5.31654 13.4948C5.76629 14.8993 7.07225 15.9215 8.61872 15.9504C7.40896 16.898 5.88414 17.4632 4.22944 17.4632C3.94323 17.4632 3.66184 17.4463 3.38525 17.4126C4.94856 18.4156 6.80769 19 8.80391 19C15.3049 19 18.862 13.6126 18.862 8.94193C18.862 8.78801 18.8596 8.63649 18.8524 8.48497C19.5426 7.98712 20.1415 7.3642 20.6153 6.6547V6.6571Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.76d00454c12fa364063aa3c2564f2651.svg";
export { ForwardRef as ReactComponent };